import { VisualizationTitleContainer, VisualizationGrid } from "../VizGrid";
import { TotalValue } from "@atlas-int/viz/shared";
import VisualizationTitleGenerator from "./VisualizationTitleGenerator";
import { FindInViz as FindInVizBase } from "@atlas-int/controls";
import type { FindInVizOption } from "@atlas-int/controls";
import { VizType } from "@atlas-int/data";
import {
  useCurrentVizType,
  useIsFeasibilityTable,
} from "../../routing/typedRoutes";
import { googleAnalyticsCustomEvent } from "../../sharedUtilities/analytics";
import { uiIcons } from "../../assets/icons";

interface VisualizationLayoutProps {
  children: React.ReactNode;
  totalValue: number | undefined;
  /** When set (e.g. over-time viz end year), TotalValue shows “(year)” after the amount. */
  totalValueYear?: number;
  findInVizOptions: FindInVizOption[];
  highlightedItem: string | undefined;
  onHighlight: (id: string | undefined) => void;
}

const VisualizationLayout: React.FC<VisualizationLayoutProps> = ({
  children,
  totalValue,
  totalValueYear,
  findInVizOptions,
  highlightedItem,
  onHighlight,
}) => {
  const vizType = useCurrentVizType();
  const isTable = useIsFeasibilityTable();

  const findInVizVisible =
    vizType !== VizType.Geo && vizType !== VizType.MarketShare && !isTable;

  return (
    <>
      <VisualizationTitleContainer>
        <TotalValue
          value={totalValue}
          year={totalValueYear}
          isOvertime={totalValueYear !== undefined}
        />
        <VisualizationTitleGenerator />
        <span data-download-exclude>
          <FindInVizBase
            options={findInVizOptions}
            highlightedItem={highlightedItem}
            onHighlight={onHighlight}
            visible={findInVizVisible}
            iconSrc={uiIcons.findInViz}
            onOpen={() =>
              googleAnalyticsCustomEvent("menu", "open", "findinviz", "explore")
            }
          />
        </span>
      </VisualizationTitleContainer>
      <VisualizationGrid>{children}</VisualizationGrid>
    </>
  );
};

export default VisualizationLayout;
